/** Runtime list of {@link BuildRecordSource}, for schemas that validate the value. */
export const BUILD_RECORD_SOURCES = [
    'airbus-aircraft-inspection-report',
    'vsl-serialized-parts-list',
    'rr-dis-serialised-parts-list',
];
/**
 * The role an airworthiness directive's own text gives a service bulletin it names (DR-5796), read
 * from an `Airworthiness Directives Reference` page: `required-action` — the AD orders an action
 * done per / in accordance with / using the bulletin's instructions; `applicability` — the bulletin
 * is the list of affected parts or serial numbers, or the source of a table the applicability cites;
 * `alternative-method` — the bulletin is approved as an alternative method of compliance;
 * `terminating-action` — doing the bulletin ends a repetitive action; `credit` — actions done
 * earlier per the bulletin are acceptable; `reference` — named in definitions, related information
 * or material incorporated by reference; `other` — none of these.
 */
export const AD_TEXT_SB_ROLES = [
    'required-action',
    'applicability',
    'alternative-method',
    'terminating-action',
    'credit',
    'reference',
    'other',
];
/**
 * Normalised shop-visit workscope depth (DR-3126). Derived DETERMINISTICALLY by the
 * sanitiser from the verbatim printed phrase in `workscopeLevelRaw` — never trusted
 * from the model's own enum pick, which is the field most prone to a plausible guess.
 * A phrase that maps to no member leaves the enum absent while the raw lane survives,
 * so a reviewer can still see what the page said.
 */
export const ENGINE_WORKSCOPE_LEVELS = ['full', 'light', 'performance-restoration'];
//# sourceMappingURL=ProcessingData.js.map